import {PRIORITY_FIELD_NAME, TaskSortBy} from '../../constants'

export const ColumnTitlesKeys = {
    [TaskSortBy.DEADLINE]: "task.list.deadline",
    [TaskSortBy.ESTIMATE]: "task.list.estimate",
    [TaskSortBy.CREATION_DATE]:  "task.list.creation_date",
    [TaskSortBy.SPENT_TIME]: "task.list.spent_time",
    [TaskSortBy.TYPE_OF_WORK]: "task.list.type_of_work",
    [TaskSortBy.LAST_TRACKING_DATE]: "task.list.last_tracking_date",
    [TaskSortBy.VARIANCE_MAN_HOURS]: "task.list.variance_man_hours",
    [TaskSortBy.VARIANCE_PERCENTS]: "task.list.variance_percents",
    [TaskSortBy.VARIANCE_PROGRESS_BAR]: "task.list.variance_progress_bar",
}

export const NOT_CONFIGURABLE_COLUMNS = [
    TaskSortBy.CUSTOMER,
    TaskSortBy.PROJECT,
    TaskSortBy.TASK,
    TaskSortBy.STATUS,
    TaskSortBy.WORKFLOW_STATUS
]

export const FIXED_COLUMNS = [
    PRIORITY_FIELD_NAME
]



// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/configurationMenu/constants.js